import { TrimLeadingZeroesPipe } from './trim-leading-zeroes.pipe';

export const TRIM_LEADING_ZEROES_PIPE_DECLARATIONS = [TrimLeadingZeroesPipe];

export * from './trim-leading-zeroes.pipe';
